/** Narrows a raw string to one of an enum's values, or undefined when it is not one. */
export const asEnumValue = <T extends string>(
	values: T[],
	value: string | null | undefined
): T | undefined => values.find((candidate) => candidate === value);
